var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 4.75H32.375V11.6929H29.2917V7.91667H7.70833V22.1667H14.3884V25.3333H4.625V4.75Z",
    fill: "#EB00B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5545 16.2877C20.9019 17.7523 22.0504 19 24.6666 19H27.75C28.5677 19 29.352 19.3336 29.9302 19.9275C30.5084 20.5213 30.8333 21.3268 30.8333 22.1666V23.75C30.8333 24.3058 30.6908 24.8519 30.4202 25.3332C30.1496 25.8146 29.7603 26.2144 29.2916 26.4923V34.8333H24.6666V22.1666C20.6321 22.1666 18.5678 19.8708 17.205 18.3587C17.0202 18.1503 16.8315 17.9454 16.6392 17.7444L18.8191 15.5055C19.075 15.7694 19.3201 16.0302 19.5545 16.2877ZM29.2916 15.0416C29.2916 15.6715 29.048 16.2756 28.6143 16.721C28.1806 17.1664 27.5924 17.4166 26.9791 17.4166C26.3658 17.4166 25.7776 17.1664 25.3439 16.721C24.9103 16.2756 24.6666 15.6715 24.6666 15.0416C24.6666 14.4117 24.9103 13.8076 25.3439 13.3622C25.7776 12.9168 26.3658 12.6666 26.9791 12.6666C27.5924 12.6666 28.1806 12.9168 28.6143 13.3622C29.048 13.8076 29.2916 14.4117 29.2916 15.0416Z",
    fill: "#EB00B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeven);
export default __webpack_public_path__ + "static/media/seven.6cb9025a932b90c9ee2e8654108ea81d.svg";
export { ForwardRef as ReactComponent };